<template>
  <div class="main-view-padding has-header">
    <div class="header main" v-header-position-lock>
      <div class="align-left"></div>
      <div class="align-middle">
        <headerbuttonstack :state="headerButtons" />
      </div>
      <div class="align-right"></div>
    </div>
    <div
      style="
        font-size: 32px;
        text-align: left;
        color: #e51550;
        border-bottom: 1px solid #ccc;
        padding: 5px;
        font-weight: 400;
        margin-bottom: 25px;
      "
    >
        {{ $t('settings.wage.wageTypesExternalLink') }}
    </div>

    <div class="xColumn3">
      <strong style="font-size: 16px">{{ $t('settings.wage.commonWageTypes') }}</strong>
      <br />

      <table class="styled-table" style="margin-top: 7px">
        <tr>
            <th>{{ $t('settings.wage.label') }}</th>
            <th class="center">{{ $t('settings.wage.externalId') }}</th>
          <th class="center">{{ $t('settings.ui.edit') }}</th>
        </tr>
        <tr v-for="wageType in wTMMain" v-bind:key="'wageTypesTr' + wageType.enumId">
          <td>
            <strong>{{ $t(`wageTypes.md.${wageType.enumId}`) }}</strong>
          </td>
          <td class="center">
            <strong>{{ wageType.externalId }}</strong>
          </td>
          <td class="center" style="text-align: center">
            <button class="icon-button" v-tooltip="$t('settings.wage.editExternalId')" v-on:click="openEditWageType(wageType)">
              <i class="fas fa-edit"></i>
            </button>
          </td>
        </tr>
      </table>
    </div>

    <div class="xColumn3">
      <strong style="font-size: 16px">{{ $t('settings.wage.allOtherWageTypes') }}</strong>
      <br />

      <table class="styled-table" style="margin-top: 7px">
        <tr>
          <th>{{ $t('settings.wage.label') }}</th>
          <th class="center">{{ $t('settings.wage.externalId') }}</th>
          <th class="center" style="text-align: center">{{ $t('settings.ui.edit') }}</th>
        </tr>
        <tr v-for="wageType in wTMNMain" v-bind:key="'wageTypesTr' + wageType.enumId">
          <td>
            <strong>{{ $t(`wageTypes.md.${wageType.enumId}`) }}</strong>
          </td>
          <td class="center">
            <strong>{{ wageType.externalId }}</strong>
          </td>
          <td class="center" style="text-align: center">
            <button class="icon-button" v-tooltip="$t('settings.wage.editExternalId')"  v-on:click="openEditWageType(wageType)">
              <i class="fas fa-edit"></i>
            </button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import button from "../uicomponents/button.vue";
export default {
  components: { button },
  name: "WageTypes",
  data() {
    return {
      loading: true,
      saves: false,

      wageTypesMapping: [],
    };
  },
  created: function () {
    if (this.$store.state.jwt != undefined && this.$store.state.companyId != undefined) {
      this.refresh();
    }
  },
  mounted: function () {},
  computed: {
    ...mapGetters(["companyId"]),
    headerButtons() {
      let view = this;

      let state = {
        buttons: [],
      };
      state.buttons.push({
        type: "block",
        icon: "fa-refresh",
        click: () => {
          view.refresh();
        },
          tooltip: view.$t('settings.wage.reloadData')
      });
      /*
      state.buttons.push({
        type: "block",
        icon: "fa-wand-magic",
        click: ($event) => {
          view.fillDefaultValues($event);
        },
        tooltip: "BMD Standard verwenden",
      });
      */
      return state;
    },
    wTMMain() {
      let x = [];
      let mainIDs = [40, 42, 44, 46, 48, 50, 52, 53, 59, 61, 73, 74];
      for (let i in this.wageTypesMapping) {
        if (mainIDs.includes(this.wageTypesMapping[i].enumId)) {
          x.push(this.wageTypesMapping[i]);
        }
      }
      return x;
    },
    wTMNMain() {
      let x = [];
      let mainIDs = [40, 42, 44, 46, 48, 50, 52, 53, 59, 61, 73, 74];
      for (let i in this.wageTypesMapping) {
        if (!mainIDs.includes(this.wageTypesMapping[i].enumId)) {
          x.push(this.wageTypesMapping[i]);
        }
      }
      return x;
    },
  },
  watch: {
    companyId: function (val, oldVal) {
      this.refresh();
    },
  },
  // methods that implement data logic.
  methods: {
    refresh: function (force = false) {
      let view = this;
      view.loading = true;
      view.loadEnumWageTypes();
    },

    loadEnumWageTypes: function () {
      let view = this;
      let url = "/api/enum/wagetype";
      this.axios({
        method: "get",
        headers: {},
        url: url,
      })
        .then((response) => {
          let data = response.data;
          let tmp = [];
          for (let i = 0; i < data.length; i++) {
            let item = {
              enumId: data[i].id,
              enumKey: data[i].key,
              enumValueGER: data[i].valueGER,
              enumValueENG: data[i].valueENG,
            };
            tmp.push(item);
          }
          view.wageTypesMapping = tmp.slice();
          view.loadWageTypesMapping();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    loadWageTypesMapping: function () {
      let view = this;
      //let params = { companyId: view.$store.state.companyId };
      let params = {};
      view.$helpers
        .GetCall("/api/sec/mapping/wagetype", params)
        .then((response) => {
          for (let i = 0; i < view.wageTypesMapping.length; i++) {
            view.wageTypesMapping[i].externalId = "";
            for (let j = 0; j < response.data.data.length; j++) {
              let tmp = response.data.data[j];
              if (parseInt(view.wageTypesMapping[i].enumId) == parseInt(tmp.wageTypeId)) {
                view.wageTypesMapping[i].id = tmp.id;
                view.wageTypesMapping[i].originalExternal = tmp.externalId;
                view.wageTypesMapping[i].externalId = tmp.externalId;
              }
            }
          }
          view.$forceUpdate();
        })
        .catch((e) => {
          view.loading = false;
          console.log(e);
        });
    },

    openEditWageType(wageType) {
      let view = this;
      let description = wageType.enumValueGER;

      let dataEntries = [
        {
          label: "id: ",
          key: "id",
          hidden: true,
          type: "text",
          value: wageType.enumId,
          length: 128,
          styles: { width: "350px" },
        },
        {
          label: view.$t('settings.groups.number') + ': ',
          key: "externalId",
          hidden: false,
          type: "numeric",
          value: wageType.externalId,
          styles: { width: "150px" },
        },
        { flexDivider: true, styles: { "margin-bottom": "23px" } },
      ];
      this.$helpers.OpenPopup({
        elRelative: null,
        type: "datafill",
        pointerDirection: 0,
        componentState: {
          entries: dataEntries,
          description: description,
          selectCallback: function (x) {
            view.editWageType(x);
          },
          deleteCallback: function (x) {
            view.deleteWageTypeMapping(x);
          },
          errorCheck: {
            'externalId': (entries) => {
              if (!entries.hasOwnProperty('externalId') || entries.externalId === '') {
                return {
                  key: 'externalId',
                  label: view.$t('settings.groups.number'),
                  type: 'error',
                  text:  view.$t('settings.wage.mustBeProvided')
                }
              } else {
                return null;
              }
            },
          },
        },
        header: view.$t('settings.wage.editWageType'),
        remainAfterSelect: false,
        centered: true,
        expanded: true,
      });
    },
    editWageType(wageType) {
      let view = this;
      let url = "/api/sec/mapping/wagetype/" + wageType.id;
      let payload = {
        companyId: this.$store.state.companyId,
        externalId: wageType.externalId,
      };
      this.axios({
        method: "put",
        headers: {
          AUTHORIZATION: "Bearer " + view.$store.state.jwt,
        },
        url: url,
        data: payload,
      })
        .then((response) => {
            view.$helpers.success(
                view.$t('settings.wage.wageTypeUpdated'),
                view.$t('settings.wage.wageTypeUpdated')
            );
            view.refresh(true);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    deleteWageTypeMapping(wageType) {
      let view = this;
      let url = "/api/sec/mapping/wagetype/" + wageType.id;
      let payload = {
        companyId: this.$store.state.companyId,
      };
      this.axios({
        method: "delete",
        headers: {
          AUTHORIZATION: "Bearer " + view.$store.state.jwt,
        },
        url: url,
        data: payload,
      })
        .then((response) => {
            view.$helpers.success(
                view.$t('settings.wage.deletedTitle'),
                view.$t('settings.wage.wageTypeMappingRemoved')
            );
            view.refresh(true);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    fillDefaultValues($event) {
      let view = this;
      let dataEntries = [
        {
          label: "",
          key: "number",
          hidden: false,
          type: "output",
          value: view.$t('settings.wage.overwriteAllConfirm'),
        },
        { flexDivider: true, styles: { "margin-bottom": "23px" } },
      ];
      this.$helpers.OpenPopup({
        elRelative: null,
        type: "datafill",
        pointerDirection: 0,
        componentState: {
          positiveButtonLabel: view.$t('settings.wage.restoreDefaults'),
          entries: dataEntries,
          selectCallback: function () {
            view.editWageType({ id: 0, externalId: 0 });
            view.editWageType({ id: 1, externalId: 0 });
            view.editWageType({ id: 2, externalId: 0 });
            view.editWageType({ id: 3, externalId: 0 });
            view.editWageType({ id: 4, externalId: 0 });
            view.editWageType({ id: 5, externalId: 0 });
            view.editWageType({ id: 6, externalId: 0 });
            view.editWageType({ id: 7, externalId: 0 });
            view.editWageType({ id: 8, externalId: 0 });
            view.editWageType({ id: 9, externalId: 0 });
            view.editWageType({ id: 10, externalId: 0 });
            view.editWageType({ id: 11, externalId: 0 });
            view.editWageType({ id: 12, externalId: 0 });
            view.editWageType({ id: 13, externalId: 0 });
            view.editWageType({ id: 14, externalId: 0 });
            view.editWageType({ id: 15, externalId: 0 });
            view.editWageType({ id: 16, externalId: 0 });
            view.editWageType({ id: 17, externalId: 0 });
            view.editWageType({ id: 18, externalId: 0 });
            view.editWageType({ id: 19, externalId: 0 });
            view.editWageType({ id: 20, externalId: 0 });
            view.editWageType({ id: 21, externalId: 0 });
            view.editWageType({ id: 22, externalId: 0 });
            view.editWageType({ id: 23, externalId: 0 });
            view.editWageType({ id: 24, externalId: 0 });
            view.editWageType({ id: 25, externalId: 0 });
            view.editWageType({ id: 26, externalId: 0 });
            view.editWageType({ id: 27, externalId: 0 });
            view.editWageType({ id: 28, externalId: 0 });
            view.editWageType({ id: 29, externalId: 0 });
            view.editWageType({ id: 30, externalId: 0 });
            view.editWageType({ id: 31, externalId: 0 });
            view.editWageType({ id: 32, externalId: 0 });
            view.editWageType({ id: 33, externalId: 0 });
            view.editWageType({ id: 34, externalId: 0 });
            view.editWageType({ id: 35, externalId: 0 });
            view.editWageType({ id: 36, externalId: 0 });
            view.editWageType({ id: 37, externalId: 0 });
            view.editWageType({ id: 38, externalId: 0 });
            view.editWageType({ id: 39, externalId: 0 });
            view.editWageType({ id: 40, externalId: 0 });
            view.editWageType({ id: 41, externalId: 0 });
            view.editWageType({ id: 42, externalId: 0 });
            view.editWageType({ id: 43, externalId: 0 });
            view.editWageType({ id: 44, externalId: 0 });
            view.editWageType({ id: 45, externalId: 0 });
            view.editWageType({ id: 46, externalId: 0 });
            view.editWageType({ id: 47, externalId: 0 });
            view.editWageType({ id: 48, externalId: 0 });
            view.editWageType({ id: 49, externalId: 0 });
            view.editWageType({ id: 50, externalId: 0 });
            view.editWageType({ id: 51, externalId: 0 });
          },
        },
        header: view.$t('settings.wage.confirmationRequired'),
        remainAfterSelect: false,
        centered: true,
        expanded: true,
      });
    },
  },
};
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>
.xColumn3 {
  width: 40%;
  text-align: left;
  float: left;
  margin-left: 5%;
  margin-right: 5%;
  overflow-y: auto;
}
</style>
